// extracted by mini-css-extract-plugin
module.exports = {"creditContainer":"Credits-module_creditContainer_TLwk7","creditText":"Credits-module_creditText_35lYd","link":"Credits-module_link_2PY7F"};